
import { slideToggle, toggleAria } from '../utils.js';
import 'core-js/es/array';

export default class Accordion {

    constructor() {

        // Accordion
        this.accordionHead = Array.from(document.querySelectorAll('.js-accordion-btn'));

        if (this.accordionHead) this.init();

    }

    init() {

        this.accordionHead.forEach(link => link.addEventListener('click', (ev) => {

            if (link.classList.contains('no-click')) return;
            if (link.classList.contains('c-f__head') && window.innerWidth > 800) return;

            const textEl = link.querySelector('.c-accordion__header-text');

            if(textEl) {
                if(!link.classList.contains('active')) link.querySelector('.c-accordion__header-text').innerHTML = textEl.dataset.open; 
                else link.querySelector('.c-accordion__header-text').innerHTML = textEl.dataset.closed;
            }

            link.classList.add('no-click');
            link.classList.toggle('active');
            slideToggle(link.nextElementSibling, 200);
            toggleAria(link, 'aria-expanded');

            setTimeout(() => { link.classList.remove('no-click'); }, 250);

        }));

    }

}